<template>

    <m-edit1/>

    <m-single-product-201 v-bind='{...{"productLink":null,"relatedProducts":true,"productCardName":"mProductCard207_price","relatedCourse":false,"galleryFullSlider":false,"productAuthor":false},...{}}' :style='""' class="my-3 container" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col-12" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='"border-radius: 15px;"' class="col-11 mx-auto text-center bg-danger shadow " >
                <template #default>   <m-h3 v-bind='{...{},...{}}' :style='"font-size: 15px;"' class="text-white p-3" >
                <template #default>در هنگام خرید به اسم کالا که شامل تعداد در بسته بندی است توجه فرمایید   </template>
                </m-h3></template>
                </m-div></template>
                </m-div></template>
                </m-single-product-201>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mSingleProduct201 from '@moeinmdn/miw-alpha-components/src/package/Product/Single/SingleProduct201'; import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mH3 from '@moeinmdn/miw-alpha-components/src/package/Tags/H3';

export default {
    name: 'HomeView',
    components: {mEdit1, mSingleProduct201,mDiv,mH3 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
